import { ApiAddress } from '@/services/apis'
import request from '@/services/request'
import { TOKEN_NAME } from '@/utils/constants'
import md5 from 'blueimp-md5'
import { Passport } from './passport.model'
import { User } from '../user/user.model'

export function login(data: Passport.SignInData) {
  data.password = md5(data.password)

  return request.post(ApiAddress.SIGN_IN, data).then((data: any) => {
    saveToken(data.token)
    return data
  })
}

export function register(data: Passport.SignUpData) {
  data.password = md5(data.password)

  return request.post(ApiAddress.SIGN_UP, data)
}

export function saveToken(token: string) {
  localStorage.setItem(TOKEN_NAME, token)
}

export function removeToken() {
  localStorage.removeItem(TOKEN_NAME)
}

export function resendActiveEmail(email: string) {
  return request.post(ApiAddress.REGISTER_VERIFY_RESEND, {email})
}

export function forgotPassword(email) {
  return request.post(ApiAddress.FORGOT_PASSWORD, {email})
}

export function resetPassword(password: string, token: string) {
  return request.put(ApiAddress.RESET_PASSWORD, {password}, {params: {token}})
} 

export function verifyUserEmail(token: string): Promise<User.Info> {
  return request.get(ApiAddress.VERIFY_USER_EMAIL, {params: {token}})
}